import { SubNavigation } from '@layouts/Header/Header.types';
import React from 'react';

interface SubMenuProps {
  submenuLinks: SubNavigation['content'];
}

export const SubMenu = ({ submenuLinks }: SubMenuProps) => {
  const subMenuLinks = submenuLinks.map((item, index) => {
    const activeStyle = parseInt(window.pageId) === parseInt(item.PageId) ? 'is-active' : '';
    return (
      <li key={index} className='c-submenu-link-container'>
        <a href={item.Href} className={`c-submenu-link ${activeStyle}`}>
          {item.Text}
        </a>
      </li>
    );
  });

  return (
    <div className='c-submenu'>
      <ul className='c-submenu-list'>{subMenuLinks}</ul>
    </div>
  );
};
